(function () {
  'use strict';
  if (window.top1ProductGalleryLoaded) return;
  window.top1ProductGalleryLoaded = true;
  // Posters are held in data-poster so they never download until the video is revealed.
  function revealPosters(scope) {
    if (!scope) return;
    var videos = scope.matches && scope.matches('video[data-poster]') ? [scope] : scope.querySelectorAll('video[data-poster]');
    Array.prototype.forEach.call(videos, function (video) {
      if (!video.getAttribute('poster') && video.dataset.poster) video.setAttribute('poster', video.dataset.poster);
    });
  }
  var posterObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { revealPosters(entry.target); posterObserver.unobserve(entry.target); }
    });
  }, { rootMargin: '200px 0px' }) : null;
  function watchPosters(container) {
    // Hidden gallery panels never intersect; selecting a panel reveals its poster instead.
    container.querySelectorAll('[data-top1-media] video[data-poster]').forEach(function (video) {
      if (posterObserver) posterObserver.observe(video); else revealPosters(video);
    });
  }
  function init(gallery) {
    if (gallery.dataset.galleryReady) return;
    var panels = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-panel]'));
    var stage = gallery.querySelector('[data-gallery-stage]');
    var choices = gallery.querySelector('[data-gallery-choices]');
    var controls = gallery.querySelector('[data-gallery-controls]');
    if (!panels.length || !stage || !choices || !controls) return;
    if (panels.length < 2) { revealPosters(panels[0]); gallery.dataset.galleryReady = 'true'; return; }
    var selected = 0, buttons = [];
    function pause(panel) {
      panel.querySelectorAll('video').forEach(function (video) { video.pause(); });
      panel.querySelectorAll('iframe').forEach(function (frame) {
        if (frame.getAttribute('src')) { frame.dataset.gallerySrc = frame.getAttribute('src'); frame.removeAttribute('src'); }
      });
    }
    function restoreFrames(panel) {
      panel.querySelectorAll('iframe').forEach(function (frame) { if (frame.dataset.gallerySrc && !frame.getAttribute('src')) frame.setAttribute('src', frame.dataset.gallerySrc); });
    }
    function show(index, focus) {
      selected = (index + panels.length) % panels.length;
      panels.forEach(function (panel, i) {
        var on = i === selected;
        panel.hidden = !on;
        buttons[i].setAttribute('aria-pressed', String(on));
        var mark = buttons[i].querySelector('[data-gallery-selected]');
        if (mark) mark.hidden = !on;
        if (panel.hidden) pause(panel);
        else { restoreFrames(panel); revealPosters(panel); }
      });
      gallery.querySelector('[data-gallery-status]').textContent = (selected + 1) + ' of ' + panels.length + ' - ' + panels[selected].dataset.galleryLabel;
      if (focus) buttons[selected].focus();
    }
    panels.forEach(function (panel, index) {
      stage.appendChild(panel);
      var button = document.createElement('button');
      button.type = 'button'; button.dataset.gallerySelect = String(index);
      button.setAttribute('aria-controls', panel.id);
      if (panel.dataset.galleryThumb) {
        var image = document.createElement('img'); image.src = panel.dataset.galleryThumb;
        image.alt = ''; image.width = 80; image.height = 52; image.loading = 'lazy';
        button.appendChild(image);
      }
      var name = document.createElement('span'); name.textContent = panel.dataset.galleryLabel;
      button.appendChild(name);
      // Selected is shown with a tick and a word, never by border alone. aria-pressed carries it to assistive technology.
      var mark = document.createElement('span'); mark.className = 'top1-gallery__selected'; mark.dataset.gallerySelected = '';
      mark.setAttribute('aria-hidden', 'true'); mark.textContent = '\u2713 Selected'; mark.hidden = true;
      button.appendChild(mark);
      choices.appendChild(button); buttons.push(button);
    });
    gallery.addEventListener('click', function (event) {
      var button = event.target.closest('button'); if (!button || !gallery.contains(button)) return;
      if (button.hasAttribute('data-gallery-select')) show(Number(button.dataset.gallerySelect), false);
      else if (button.hasAttribute('data-gallery-step')) show(selected + Number(button.dataset.galleryStep), false);
    });
    choices.addEventListener('keydown', function (event) {
      var focused = event.target.closest('[data-gallery-select]');
      if (!focused) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(Number(focused.dataset.gallerySelect) + (event.key === 'ArrowRight' ? 1 : -1), true); }
      else if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); show(event.key === 'Home' ? 0 : panels.length - 1, true); }
    });
    gallery.addEventListener('top1:product-photo', function (event) {
      var hero = gallery.querySelector('.top1-bundle__hero-image');
      var thumb = buttons[0].querySelector('img');
      if (hero && thumb) { var url = new URL(hero.src, location.href); url.searchParams.set('width', '160'); thumb.src = url.href; }
      if (event.detail && event.detail.reveal) show(0, false);
    });
    // Other scripts (for example a variant picker) can ask for a panel by id.
    gallery.addEventListener('top1:gallery-show', function (event) {
      var id = event.detail && event.detail.id;
      for (var i = 0; i < panels.length; i++) if (panels[i].id === id) { show(i, false); break; }
    });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) { entries.forEach(function (entry) { if (!entry.isIntersecting) pause(entry.target); else if (!entry.target.hidden) restoreFrames(entry.target); }); }, { threshold: 0.05 });
      panels.forEach(function (panel) { observer.observe(panel); });
      gallery.top1GalleryObserver = observer;
    }
    show(0, false);
    gallery.top1GalleryVisibility = function () { if (document.hidden) panels.forEach(pause); else restoreFrames(panels[selected]); };
    var fallback = gallery.querySelector('[data-gallery-fallback]');
    if (fallback) fallback.hidden = true;
    controls.hidden = false; gallery.dataset.galleryReady = 'true';
  }
  function initialise(container) { container.querySelectorAll('[data-top1-gallery]').forEach(init); watchPosters(container); }
  initialise(document);
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('[data-top1-gallery]').forEach(function (gallery) { if (gallery.top1GalleryObserver) gallery.top1GalleryObserver.disconnect(); }); });
  document.addEventListener('visibilitychange', function () { document.querySelectorAll('[data-top1-gallery]').forEach(function (gallery) { if (gallery.top1GalleryVisibility) gallery.top1GalleryVisibility(); }); });
  // An opened no-JS-style disclosure reveals its posters too.
  document.addEventListener('toggle', function (event) { if (event.target.open) revealPosters(event.target); }, true);
})();
